import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { FilterService } from "../../services/filter.service";
import { AutoUnsubscribe } from "../../shared/decorators";

@Component({
  standalone: false,
  selector: "dua-filters",
  templateUrl: "./filters.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./filters.component.scss"],
})
@AutoUnsubscribe()
export class FiltersComponent implements OnInit, OnDestroy {
  hasActiveFilters = false;
  cardBlocksFilters = false;

  private filterChangeSubscription!: Subscription;
  private resetSubscription!: Subscription;

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    this.refreshResetState();
    this.filterChangeSubscription = this.filterService
      .getFilterChanges()
      .subscribe(() => this.refreshResetState());
    this.resetSubscription = this.filterService
      .getResetFilterTrigger()
      .subscribe(() => this.refreshResetState());
  }

  get resetTooltip(): string {
    if (this.cardBlocksFilters) {
      return "Filter är låsta medan en annons är öppen";
    }
    if (!this.hasActiveFilters) {
      return "Inga filter att rensa";
    }
    return "Rensa filter";
  }

  canResetFilters(): boolean {
    return this.hasActiveFilters && !this.cardBlocksFilters;
  }

  resetFilter() {
    if (!this.canResetFilters()) {
      return;
    }
    this.filterService.resetFilter();
  }

  private refreshResetState() {
    this.hasActiveFilters = this.filterService.hasActiveFilters();
    this.cardBlocksFilters = this.filterService.isDisabled();
  }

  ngOnDestroy() {}
}
